import { createContext, useContext } from 'react';

enum Logos {
  ALJEX = 'ALJEX',
  TRIUMPH = 'TRIUMPH',
  DAT = 'DAT',
  DRAYRATES = 'DRAYRATES',
  DTS = 'DTS',
  SUNSET = 'SUNSET',
  TABI = 'TABI',
  WERNER = 'WERNER',
  ARCBEST = 'ARCBEST',
  ECHO = 'ECHO',
  TRANSFIX = 'TRANSFIX',
  BITFREIGHTER = 'BITFREIGHTER',
  WWEX = 'WWEX',
  FASTMORE = 'FASTMORE',
  WORLDWIDE_LOGISTICS = 'WORLDWIDE_LOGISTICS',
  AVRL = 'AVRL',
  CUSTOM = 'CUSTOM',
  HOSTED_MCLEOD = 'HOSTED_MCLEOD',
  TRUCKSTOP = 'TRUCKSTOP',
  NTG = 'NTG',
  SONAR = 'SONAR',
  TURVO = 'TURVO',
  REVENOVA = 'REVENOVA',
  SOFTMODAL = 'SOFTMODAL',
}
export type LogosURLsContextType = {
  logos: Record<Logos, string>;
};

export const LogosURLsContext = createContext<LogosURLsContextType>(
  buildEmptyContext()
);

export enum ApiReqType {
  PLACES = 'PLACES',
}

export function useLogosContext(): LogosURLsContextType['logos'] {
  const context = useContext(LogosURLsContext);

  if (!context) {
    throw new Error('APIContext must be used within a APIContextProvider');
  }
  return context.logos;
}

function buildEmptyContext(): LogosURLsContextType {
  return {
    logos: {
      ALJEX: '',
      TRIUMPH: '',
      DAT: '',
      DRAYRATES: '',
      DTS: '',
      SUNSET: '',
      TABI: '',
      WERNER: '',
      ARCBEST: '',
      ECHO: '',
      TRANSFIX: '',
      BITFREIGHTER: '',
      WWEX: '',
      FASTMORE: '',
      WORLDWIDE_LOGISTICS: '',
      AVRL: '',
      CUSTOM: '',
      HOSTED_MCLEOD: '',
      TRUCKSTOP: '',
      NTG: '',
      SONAR: '',
      TURVO: '',
      REVENOVA: '',
      SOFTMODAL: '',
    },
  };
}
